<template>
  <div class="grid-y flex-grow relative pb-24 service-category-new">
    <div class="cell auto cell-block-y flex flex-col flex-grow">
      <div class="flex flex-col flex-grow p-8 space-y-8">
        <Input
            label="Название категории:"
            placeholder="Введите название"
            classes="bg-hint w-110"
            :invalid="$v.category.name.$error"
            v-model="category.name"/>
        <Input
            label="Аббревиатура категории:"
            placeholder="Введите подходящую аббревиатуру для категории"
            classes="w-110"
            maxInputLength="2"
            :invalid="$v.category.abbreviation.$error"
            v-model="category.abbreviation"/>
        <Input
            label="Описание:"
            :textarea="true"
            placeholder="Введите описание категории услуг"
            classes="w-150"
            :invalid="$v.category.description.$error"
            v-model="category.description"/>
        <div class="flex flex-col">
          <span class="flex text-sm text-muted mb-3">Иконка категории для старой формы:</span>
          <Select
            :icons="true"
            v-if="attach && attach.length"
            :options="attach"
            class="bg-hint w-72"
            :label="'name'"
            :value="category.iconAttach"
            @input="($event) => category.iconAttach = $event"
            placeholder="Выберите текущую иконку категории"/>
        </div>
        <V2AttachmentUpload
          mode="icon"
          v-model="category.v2IconAttach"
          title="Иконка категории для новой формы"
          hint="Необязательно. Если не загрузить, новая форма и приложение используют старую иконку категории. Лучше квадратное изображение 512×512."
        />
        <div class="flex flex-col space-y-2">
          <Check
            v-model="category.onePerOrder"
            label="Не более одной основной услуги этой категории"
          />
          <span class="text-12px text-gray-600 max-w-150">
            Включите для категорий вроде уборки, где пользователь выбирает один основной вариант.
            Обязательные услуги добавляются автоматически и не занимают этот лимит.
            Выключите для благоустройства и других категорий, где допустимо несколько основных услуг.
          </span>
        </div>
      </div>
      <div class="px-16 py-8 font-bold border-t border-b border-solid border-light">
        <span>Как это работает:</span>
      </div>
      <div class="flex flex-col">
        <template v-for="(offer, index) in category.offers">
          <CategoryOffer
            class="px-16"
            @offer-cancel="onOfferCancel"
            @new-offer-cancel="onNewOfferCancel"
            :offers="category.offers"
            ref="categoryOffer"
            @ready="isReady => readyToSubmit = isReady"
            :key="index"
            :isEditDisabled="true"
            :index="index"
            :offer="offer"
            :editing="true" />
        </template>
        <div class="flex items-center justify-center py-8">
          <span
            v-if="category.offers.length < 5"
            class="cursor-pointer flex flex-row items-center"
            @click="addField">
            <span class="btn-plus mr-2"></span>
            <b class="text-15px leading-21px text-primary">Добавить опцию</b>
          </span>
        </div>
      </div>
    </div>
    <div class="cell absolute bottom-0 min-h-90px px-8 items-center justify-center flex
    shadow-top service-category-savebar">
      <div class="flex flex-row flex-grow justify-center items-center space-x-2">
      <button
        class="btn btn-xs btn-outline-primary flex-grow max-w-150px"
        @click="onCancelClick">Отменить</button>
      <button
        class="btn btn-xs btn-primary flex-grow max-w-180px"
        @click="createServiceCategory">Сохранить</button>
    </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import Input from '@/components/Input.vue';
import Select from '@/components/Select.vue';
import CategoryOffer from '@/components/Services/CategoryOffer.vue';
import Check from '@/components/Check.vue';
import V2AttachmentUpload from '@/components/Services/V2AttachmentUpload.vue';

export default {
  components: {
    Input,
    Select,
    CategoryOffer,
    Check,
    V2AttachmentUpload,
  },
  data() {
    return {
      readyToSubmit: false,
      category: {
        name: '',
        abbreviation: '',
        description: '',
        archive: false,
        iconAttach: null,
        v2IconAttach: null,
        onePerOrder: false,
        offers: [
          {
            id: +new Date(),
            name: '',
            description: '',
          },
        ],
      },
    };
  },
  validations: {
    category: {
      name: {
        required,
      },
      abbreviation: {
        required,
      },
      description: {
        required,
      },
    },
  },
  computed: {
    ...mapState({
      attach: (state) => state.services.attach,
    }),
  },
  watch: {
    'category.iconAttach': {
      handler(value) {
        this.$emit('input', value);
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(
      'services',
      [
        'ACT_FETCH_SERVICE_CATEGORIES_ATTACH',
        'ACT_FETCH_SERVICE_CATEGORIES',
        'ACT_CREATE_SERVICE_CATEGORY',
      ],
    ),
    async getServiceCategories() {
      await this.ACT_FETCH_SERVICE_CATEGORIES();
    },
    async getServiceCategoriesAttach() {
      await this.ACT_FETCH_SERVICE_CATEGORIES_ATTACH();
    },
    addField() {
      this.category.offers.push({
        id: +new Date(),
        name: '',
        description: '',
      });
    },
    onCancelClick() {
      this.$router.go(-1);
    },
    onOfferCancel(e, isEditing, beforeEditingOffer) {
      this.category.offers = this.category.offers.map((el) => {
        if (el.id === beforeEditingOffer.id) {
          return beforeEditingOffer;
        }
        return el;
      });
    },
    onNewOfferCancel({ id }) {
      if (this.category.offers.length > 1) {
        this.category.offers = this.category.offers.filter((offer) => offer.id !== id);
      }
    },
    async createServiceCategory() {
      this.$nextTick(() => {
        this.$refs.categoryOffer.forEach((el) => {
          el.touch();
        });
      });
      this.$v.$touch();
      if (!this.$v.$invalid && this.readyToSubmit) {
        await this.ACT_CREATE_SERVICE_CATEGORY(this.category).then(() => {
          this.$router.push({
            name: 'services.categories',
          });
        }).catch((error) => {
          console.log(error);
        });
      }
    },
  },
  mounted() {
    this.getServiceCategoriesAttach();
  },
};
</script>
